import { cn } from '@/lib/cn';
import type { ReactNode } from 'react';

interface PageShellProps {
  header?: ReactNode;
  children: ReactNode;
  contentClassName?: string;
}

export function PageShell({ header, children, contentClassName }: PageShellProps) {
  return (
    <div className="flex flex-col h-full min-h-0">
      {header ? (
        <div className="shrink-0 px-10 pt-8 pb-4 border-b border-border bg-background">
          {header}
        </div>
      ) : null}
      <div className={cn('flex-1 min-h-0 overflow-y-auto px-10 py-6', contentClassName)}>
        {children}
      </div>
    </div>
  );
}
